import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import Alert from '@mui/material/Alert';
import { units } from '../theme/units';
const useNotificationStyles = makeStyles()(theme => ({
    root: {
        color: theme.palette.grey[700],
        backgroundColor: theme.palette.grey[50],
        [theme.breakpoints.down('md')]: {
            border: units.border(1, 'solid', theme.palette.grey[200]),
        },
    },
    icon: {
        color: 'inherit !important',
    },
}));
const ExtendedAlert = ({ severity, ...props }) => {
    const alertProps = { ...props };
    const isNotification = React.useMemo(() => severity === 'notification', [severity]);
    const { classes: notificationStyles } = useNotificationStyles();
    const classes = React.useMemo(() => (isNotification ? notificationStyles : {}), [isNotification, notificationStyles]);
    if (isNotification) {
        alertProps.icon = props.icon ? props.icon : false;
    }
    return (_jsx(Alert, { severity: isNotification ? undefined : severity, classes: classes, ...alertProps }));
};
const AlertLabs = React.memo(ExtendedAlert);
export { AlertLabs };
